// extracted by mini-css-extract-plugin
module.exports = {"header":"SafariOverviewHeader_header__3vbM7","title":"SafariOverviewHeader_title__1OnDF"};